import React from 'react';
import PropTypes from 'prop-types';

//------------------------------------------------------------------------------
// PROPS AND METHODS PROVIDER:
//------------------------------------------------------------------------------
class FormProps extends React.PureComponent {
  state = {
    loading: false,
    errors: [],
  };

  onSucessFullyValidated = async values => {
    this.setState({ loading: false });
    setTimeout(() => this.props.form.resetFields(), 1000); // reset the form fields,
    this.props.handleSubmit(values); // pass up the form values
  };

  onValidateError = err => {
    this.setState({ loading: false });
    // TODO handle errors better in set state
    return console.log(err);
  };

  onSubmit = e => {
    e.preventDefault(); // don't reload
    this.setState({ loading: true }); // start the loader, if needed
    this.props.form.validateFields((err, values) => {
      if (err) {
        // handle client-side validation error if needed
        return this.onValidateError(err);
      }
      // if no erros, we pass to onSucessFullyValidated
      this.onSucessFullyValidated(values);
    });
  };

  render() {
    const { children } = this.props;
    const { loading, errors } = this.state;

    // Public API
    const api = {
      loading,
      errors,
      onSubmit: this.onSubmit,
    };

    return children(api);
  }
}

FormProps.propTypes = {
  form: PropTypes.object.required,
  handleSubmit: PropTypes.func.required,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
};

export default FormProps;

//------------------------------------------------------------------------------
// PROP TYPES:
//------------------------------------------------------------------------------
export const modalPropTypes = {
  visible: PropTypes.bool.isRequired,
  open: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/render-props/form-props.js